import { transformDefinitions } from './transforms.es.js';
var isCssVar = function isCssVar(name) {
  return name.startsWith("--");
};
var registeredProperties = new Set();
function registerCssVariable(name) {
  if (registeredProperties.has(name)) return;
  registeredProperties.add(name);
  try {
    var _ref = transformDefinitions.has(name) ? transformDefinitions.get(name) : {},
      syntax = _ref.syntax,
      initialValue = _ref.initialValue;
    CSS.registerProperty({
      name: name,
      inherits: false,
      syntax: syntax,
      initialValue: initialValue
    });
  } catch (e) {}
}
export { isCssVar, registerCssVariable, registeredProperties };